import * as React from 'react';
import './floatingEventInfo.module.scss';

import iconHuman from '../images/icon-human.png';
import iconCalendar from '../images/icon-calendar.png';
import iconPlace from '../images/icon-place.png';
import iconMoney from '../images/icon-money.png';
import { Button } from '../../../../commonv2/components/Button';
import { routingStore } from '../../../../common/stores/routing';
import { V2Routes } from '../../../routes';
import { EventDetails } from '../../../types/event';
import { SimpleDate, SimpleTimeRange } from '../../../../admin/components/date/TimeRange';
import { EventStatusUtils } from '../utils/EventStatusUtils';
import { getLocationName } from '../../../../mainv3/types/location';

type Props = {
    event: EventDetails;
    alreadyReserved: boolean;
    membershipAvailable: boolean;
    appliedPrice: number;
};

export class FloatingEventInfo extends React.Component<Props> {
    render() {
        const { event, alreadyReserved, appliedPrice } = this.props;
        return (
            <div styleName="container floating-menu">
                <div styleName="row">
                    <div styleName="left-column">
                        <img src={iconCalendar} styleName="icon" />
                    </div>
                    <div styleName="right-column">
                        <div styleName="hours">
                            <SimpleDate date={event.starts_at} /> <br />
                            <SimpleTimeRange range={event} />
                        </div>
                    </div>
                </div>
                <div styleName="divider" />
                <div styleName="row">
                    <div styleName="left-column">
                        <img src={iconPlace} styleName="icon" />
                    </div>
                    <div styleName="right-column">
                        <div styleName="location">{getLocationName(event.location)}</div>
                    </div>
                </div>
                <div styleName="divider" />
                <div styleName="row">
                    <div styleName="left-column">
                        <img src={iconMoney} styleName="icon" />
                    </div>
                    <div styleName="right-column">
                        <div styleName="ticket-count">
                            {appliedPrice > 0 ? (
                                <span>
                                    参加費 <span styleName="price-no">{appliedPrice.toLocaleString()}</span> 円（税込{' '}
                                    {event.price_with_tax.toLocaleString()}円）
                                </span>
                            ) : (
                                <span>無料</span>
                            )}
                        </div>
                    </div>
                </div>
                <div styleName="divider" />
                {!EventStatusUtils.isEventFull(event) && (
                    <React.Fragment>
                        <div styleName="row">
                            <div styleName="left-column">
                                <img src={iconHuman} styleName="icon" />
                            </div>
                            <div styleName="right-column">
                                <div styleName="reservation-count">
                                    申込者
                                    <span styleName="reservation-counter">
                                        {event.active_reservation_count} / {event.capacity}
                                    </span>
                                    名
                                </div>
                            </div>
                        </div>
                        <div styleName="divider" />
                    </React.Fragment>
                )}
                <div styleName="button">
                    <Button
                        type="primary"
                        layout="inline"
                        disabled={EventStatusUtils.shouldDisable(alreadyReserved, event)}
                        onClick={() => routingStore.push(V2Routes.eventReservationPage(event.id))}
                    >
                        {EventStatusUtils.getButtonText(alreadyReserved, event)}
                    </Button>
                </div>
            </div>
        );
    }
}
